import type { LucideIcon } from "lucide-react";
import { ClipboardCheck, MessagesSquare, UserCog } from "lucide-react";
import type { InteractionMode } from "@/lib/scenarios/interactionModes";

type ModeVisual = {
  icon: LucideIcon;
  shortLabel: string;
  border: string;
  iconBg: string;
  iconFg: string;
  activeBorder: string;
  activeBg: string;
  check: string;
};

export const MODE_VISUALS: Record<InteractionMode, ModeVisual> = {
  conversational: {
    icon: MessagesSquare,
    shortLabel: "Conversational",
    border: "#CECBF6",
    iconBg: "#EFEAFE",
    iconFg: "#7C5CFF",
    activeBorder: "#7C5CFF",
    activeBg: "#F6F3FE",
    check: "#7C5CFF",
  },
  multiple_choice: {
    icon: ClipboardCheck,
    shortLabel: "Open questions",
    border: "#C9E0A0",
    iconBg: "#E8F3D8",
    iconFg: "#5E901C",
    activeBorder: "#5E901C",
    activeBg: "#F1F8E6",
    check: "#5E901C",
  },
  role_play: {
    icon: UserCog,
    shortLabel: "Role-play",
    border: "#F6DA97",
    iconBg: "#FBF3D2",
    iconFg: "#C08A05",
    activeBorder: "#C08A05",
    activeBg: "#FCF8E6",
    check: "#C08A05",
  },
};